import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";
import { BoxTick } from "iconsax-react";

export const TagWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 5,
}));

export const LoadOrderIcon = styled(BoxTick)(() => ({
  cursor: "pointer",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    padding: "0px",
  },
  content: {
    padding: "15px 32px",
  },
  containerLocation: {
    maxWidth: "150px",
  },
  button: {
    cursor: "pointer",
  },
  itemTask: {
    textAlign: "left",
  },
  cancelModalContainer: {
    width: "100%",
  },
  loadingSendToAMOS: {
    color: "#475467 !important",
  },
  menuItemText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#475467",
  },
  descriptionModalConfirm: {
    display: "flex",
    gap: "0.7rem",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    "& span": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
    },
    "& .error": {
      color: "#F04438",
      fontStyle: "italic",
    },
  },
  referenceBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "12px",
    "& > div": {
      position: "relative",
      top: "4-px",
    },
  },
}));

export default styles;
